export interface IPaletteOption {
    idColor:PaletteOptions;
    colors:Array<string>;
}

export enum PaletteOptions {
    SCOREPLAN ="1",
    OFFICE = "2",
    VIOLET = "3",
    VINTAGE = "4",
    SOFT_PASTEL = "5",
    OCEAN="6"
}


